import { render } from "./Luckbank.vue?vue&type=template&id=038042d6&scoped=true"
import script from "./Luckbank.vue?vue&type=script&lang=js"
export * from "./Luckbank.vue?vue&type=script&lang=js"

import "./Luckbank.vue?vue&type=style&index=0&id=038042d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038042d6"]])

export default __exports__